import { getSessionConfig } from "../../utils/session-helper";
import { CopyrightWrapper, FooterWrapper } from "./styled";

type FooterProps = {
  specialStylization?: boolean
}

function Footer({ specialStylization = false }: FooterProps) {
  
  return (
    <FooterWrapper
      style={specialStylization
        ? {
          width: '100vw',
          position: 'fixed',
          bottom: 0,
        }
        : {}}
    >
      <CopyrightWrapper>
        &#169; Copyright {new Date().getFullYear()} {getSessionConfig().Nome}
      </CopyrightWrapper>

    </FooterWrapper>
  );
}

export default Footer;
